var d = {
  methods: {
    slots: function slots(s, o) {
      s === void 0 && (s = "default");
      var l = this.$slots,
        i = this.$scopedSlots,
        t = i[s];
      return t ? t(o) : l[s];
    }
  }
};
export { d as SlotsMixin };
